/* eslint-disable jsx-a11y/anchor-is-valid */
import { format } from 'date-fns'

const DownloadRow = ({ item }) => {
  const { printable } = item

  if (!printable) return null

  return (
    <div className="purchaseHb-table__row">
      <div className="purchaseHb-table__col purchaseHb-table__col-1">
        <div className="purchaseHb-table__wrap">
          <div className="checkbox">
            <input type="checkbox" />
            <span className="checkbox-ico" />
          </div>
          <div className="purchaseHb-table__img">
            {printable.image ? (
              <img
                src={`${process.env.REACT_APP_PRINT_HOST}/${printable.image}`}
                alt=""
              />
            ) : (
              <img src="/account/img/purchaseHb-2.svg" alt="" />
            )}
          </div>
          <div className="purchaseHb-table__info">
            <a
              href={`${process.REACT_APP_API_HOST}/api/printables/${printable.id}/file`}
              className="purchaseHb-link"
              target="_blank"
              rel="noreferrer"
            >
              {printable.title}
            </a>
            <a href="#" className="second-btn">
              {printable.subject?.name}
            </a>
          </div>
        </div>
      </div>
      <div className="purchaseHb-table__col purchaseHb-table__col-2">
        {Number(printable.price) > 0
          ? `$${Number(printable.price).toFixed(2)}`
          : 'FREE'}
      </div>
      <div className="purchaseHb-table__col purchaseHb-table__col-3">
        {printable.created_at &&
          format(new Date(printable.created_at), 'MMM d')}
      </div>
      {/* <div className="purchaseHb-table__col purchaseHb-table__col-5">
        <ul className="purchaseHb-list">
          <li>
            <a
              download
              href={`${process.REACT_APP_API_HOST}/printable-worksheets/${printable.slug}`}
              className="hb-ico print-ico"></a></li>
          <li><a href="#" onClick={onDelete} className="hb-ico trash2-ico"></a></li>
        </ul>
      </div> */}
    </div>
  )
}

export default DownloadRow
